module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "left-1"
  }, [_vm._v("The mind is its own place,")]), _vm._v(" "), _c('p', {
    staticClass: "left-2"
  }, [_vm._v("and in itself")]), _vm._v(" "), _c('p', {
    staticClass: "left-2"
  }, [_vm._v("Can make a heaven of Hell,")]), _vm._v(" "), _c('p', {
    staticClass: "left-2"
  }, [_vm._v("a hell of Heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "left-4"
  }, [_vm._v("—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JOHN MILTON")]), _vm._v(" ("), _c('i', [_vm._v("Paradise Lost")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "left-3"
  }, [_vm._v("This is where the world is made—out here in Hell. But there is no sense to Hell when there are no people in Heaven. Some of us must choose Hell, some Heaven. I have made my choice. And I intend to rule this place if I can, if only to make some sense of it!")]), _vm._v(" "), _c('p', {
    staticClass: "left-4"
  }, [_vm._v("—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MACK BOLAN")]), _vm._v(" (his War Journal)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3694532a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 75
// module chunks = 0